import { createReducer, on } from "@ngrx/store";
import { initialAuthState } from "../state/auth.state";
import { login_failed, login_success } from "../action/login.action";
import { AuthService } from "src/app/services/common/auth.service";

export function loginReducer(state, action) {
  return _loginReducer(state, action);
}

const _loginReducer = createReducer(
  initialAuthState,
  on(login_success, (state, action) => {
    AuthService.setToken(action.bearer_token);
    return {
      ...state,
      userAuthenticated: true,
      bearerToken: action.bearer_token,
    };
  }),
  on(login_failed, (state) => {
    return {
      ...state,
      userAuthenticated: false,
      bearerToken: null,
    };
  })
);
